var KG = {
  sel: {
    model: null,
    drops: [],
    acfs: null,   // Auto-Cocking Fussschalter
    flexion: null,
    lad: null,
    tensionfs: null, // Tension Fussschalter
    hp: null,
    lat: null,
    chest: null,
    pelvic: null,
    elev: null,
    tbar: null,
    farbe: null,
    zub: []
  },

  MODELS: [
    {id:"fxm", n:"FX Manual",       s:"Manual Cocking 230V",  sku:"1202391", c:"manual", ser:"fx",     h:"fx-table-230v"},
    {id:"fxa", n:"FX Auto",         s:"Auto-Cocking 230V",    sku:"1202399", c:"auto",   ser:"fx",     h:"ergostyle-fx-auto-cocking-table-230v"},
    {id:"hym", n:"Hylo Manual",     s:"Manual Cocking 230V",  sku:"1202368", c:"manual", ser:"hylo",   h:"ergostyle-elevating-hylo"},
    {id:"hya", n:"Hylo Auto",       s:"Auto-Cocking 230V",    sku:"1202385", c:"auto",   ser:"hylo",   h:"ergostyle-elevating-hylo-1"},
    {id:"esm", n:"ES2000 Manual",   s:"Manual Cocking 230V",  sku:"1202386", c:"manual", ser:"es2000", h:"es2000-gen-ii-table-230v"},
    {id:"esa", n:"ES2000 Auto",     s:"Auto-Cocking 230V",    sku:"1202387", c:"auto",   ser:"es2000", h:"es2000-gen-ii-auto-cocking-table-230v"}
  ],
  DROPS: [
    {id:"dt", n:"Thoracic Manual Drop", d:"Brustwirbel-Sektion",    sku:"1202400", h:"thoracic-manual-drop"},
    {id:"dl", n:"Lumbar Manual Drop",   d:"Lendenwirbel-Sektion",   sku:"1202401", h:"lumbar-manual-drop"},
    {id:"dp", n:"Pelvic Manual Drop",   d:"Becken-Sektion",          sku:"1202402", h:"pelvic-manual-drop"}
  ],
  ACFS: [
    {id:"acs", n:"Single Auto-Cocking Foot Control", d:"Im Lieferumfang enthalten", sku:"1255988", h:"single-foot-control-auto-cocking", incl:true},
    {id:"acd", n:"Dual Auto-Cocking Foot Control",   d:"Zwei Pedale",               sku:"1202379", h:"dual-auto-cocking-foot-control"}
  ],
  FLEXION: [
    {id:"fm", n:"Manual Flexion",                d:"Manuelle Biegung",           sku:"1202393", h:"manual-flexion"},
    {id:"fa", n:"Auto Flexion",                  d:"Elektrisch, digit. Panel",   sku:"1202394", h:"auto-flexion-with-digital-interface-control"}
  ],
  LAD: [
    {id:"lm", n:"LAD mit Manual Flexion", d:"Long Axis Traktion",           sku:"1202395", h:"manual-flexion-w-long-axis-distraction-230v"},
    {id:"la", n:"LAD mit Auto Flexion",  d:"Long Axis Traktion elektrisch", sku:"1202396", h:"auto-flexion-w-long-axis-distraction-230v"},
    {id:"ln", n:"Ohne LAD",              d:"",                              sku:null,      h:null}
  ],
  TENSIONFS: [
    {id:"ts", n:"Single Tension Foot Control", d:"Im Lieferumfang enthalten", sku:"1332152", h:"single-tension-foot-control-1", incl:true},
    {id:"td", n:"Dual Tension Foot Control",   d:"Zwei Pedale",               sku:"1202392", h:"dual-tension-foot-control"}
  ],
  HP: [
    {id:"h1", n:"Tilt + Adjustable Face Cushions",           d:"Standard-Kopfteil",         sku:"1202369", h:"tilt-with-adjustable-face-cushion"},
    {id:"h2", n:"Tilt + Forward Drop + Toggle Drop + Adjustable Face Cushions",   d:"Mit Drop-Funktion",          sku:"1202370", h:"tilt-forward-u-toggle-drop-w-adjust-face"},
    {id:"h3", n:"Tilt + Elevation + Adjustable Face Cushions",                    d:"Mit Höhenverstellung",       sku:"1202371", h:"tilt-elevation-w-adjustable-face-cushions"},
    {id:"h4", n:"Tilt + Elevation + F/T Drop + Adjustable Face Cushions",         d:"Elevation und Drop",         sku:"1202372", h:"tilt-elevation-forward-toggle-drop"},
    {id:"h5", n:"Tilt + Cervical Distraction + Adjustable Face Cushions",         d:"Mit Zervikaltraktion",       sku:"1202375", h:"tilt-cervical-distraction-adjustable-face"},
    {id:"h6", n:"Tilt + FD/TD + Cervical Distraction + Adjustable Face Cushions", d:"Drop und Zervikaltraktion", sku:"1202376", h:"tilt-forward-drop-toggle-drop-cervical"},
    {id:"h7", n:"Tilt + Elevation + FD/TD + Cervical Distraction + Adjustable Face Cushions", d:"Vollausstattung",        sku:"1202377", h:"tilt-elevation-forward-toggle-drop-1"}
  ],
  LAT: [
    {id:"ly",  n:"Mit Lateral Flexion (14°)", d:"Seitliche Kopfbeugung", sku:"1202389", h:"lateral-flexion-head-piece-assembly"},
    {id:"lno", n:"Ohne",                      d:"",                      sku:null,      h:null}
  ],
  CHEST: [
    {id:"cs", n:"Stationary Chest",                    d:"Im Lieferumfang enthalten — alle Modelle", sku:"1202398", h:"stationary-chest",                        ser:["fx","hylo","es2000"], incl:true},
    {id:"c1", n:"Breakaway Single Control",             d:"Klappbar einseitig — alle Modelle",       sku:"1202397", h:"breakaway-chest-w-single-side-control",    ser:["fx","hylo","es2000"]},
    {id:"c2", n:"Breakaway Dual Control",               d:"Klappbar beidseitig — alle Modelle",      sku:"1238155", h:"breakaway-elev-chest-w-dual-side-control", ser:["fx","hylo","es2000"]}
  ],
  PELVIC: [
    {id:"pf", n:"Fixed Pelvic Section",     d:"Im Lieferumfang enthalten", sku:"1202384", h:"fixed-pelvic-section-to-to-ergostyle", incl:true},
    {id:"pe", n:"Elevating Pelvic Section", d:"Höhenverstellbar",          sku:"1202374", h:"elevation-pelvic-section"}
  ],
  ELEV: [
    {id:"es", n:"Single Elevation Foot Control", d:"Im Lieferumfang enthalten", sku:"1202381", h:"single-elevation-foot-control-weiss", incl:true},
    {id:"ed", n:"Dual Elevation Foot Control",   d:"Zwei Pedale",               sku:"1202382", h:"dual-elevation-foot-control-weiss"}
  ],
  TBAR: [
    {id:"ts", n:"Short T-Bar Handle", d:"Kurze Variante", sku:"1202364", h:"t-bar-handle-short"},
    {id:"tl", n:"Long T-Bar Handle",  d:"Lange Variante", sku:"1202365", h:"t-bar-handle-long"},
    {id:"tn", n:"Ohne T-Bar",         d:"",               sku:null,      h:null}
  ],
  FARBEN: [
    {id:"f1",  n:"Black",        sku:"1571897", hex:"#1a1a1a", h:"ergostyle-upholstery-black"},
    {id:"f2",  n:"Imperial Blue",sku:"1571901", hex:"#1c3f6e", h:"ergostyle-upholstery-imperial-blue"},
    {id:"f3",  n:"Blue Ridge",   sku:"1571902", hex:"#4a7ab5", h:"ergostyle-upholstery-blue-ridge"},
    {id:"f4",  n:"Forest Green", sku:"1571907", hex:"#2d6a4f", h:"ergostyle-upholstery-forest-green"},
    {id:"f5",  n:"Burgundy",     sku:"1571908", hex:"#6b1f2a", h:"ergostyle-upholstery-burgundy"},
    {id:"f6",  n:"Dove",         sku:"1571909", hex:"#d4cfc4", h:"ergostyle-upholstery-dove"},
    {id:"f7",  n:"Charcoal",     sku:"1571910", hex:"#4a4a4a", h:"ergostyle-upholstery-charcoal"},
    {id:"f8",  n:"Mocha",        sku:"1571911", hex:"#8b6347", h:"ergostyle-upholstery-mocha"},
    {id:"f9",  n:"Royal Blue",   sku:"1571912", hex:"#2c4fa0", h:"ergostyle-upholstery-royal-blue"},
    {id:"f10", n:"Lark",         sku:"1571913", hex:"#c8b89a", h:"ergostyle-upholstery-lark"},
    {id:"f11", n:"Putty",        sku:"1571914", hex:"#b8a99c", h:"ergostyle-upholstery-putty"}
  ],
  ZUB: [
    {id:"z1", n:"Kit Strap Ankle Flexion", d:"Im Lieferumfang enthalten", sku:"1330929", h:"kit-strap-ankle-flexion-table", incl:true},
    {id:"z2", n:"Cord Set Swiss",          d:"Im Lieferumfang enthalten", sku:"1608879", h:"cord-set-swiss-86515050-iec320-85101", incl:true, auto:true}
  ],

  // ─── Image cache ──────────────────────────────────────────────────────────
  _imgCache: {},

  fetchProduct: function(handle, cb) {
    if (!handle) return cb(null);
    if (this._imgCache[handle] !== undefined) return cb(this._imgCache[handle]);
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        KG._imgCache[handle] = data || null;
        cb(KG._imgCache[handle]);
      })
      .catch(function() { KG._imgCache[handle] = null; cb(null); });
  },

  imgTag: function(handle, size) {
    size = size || 120;
    var data = this._imgCache[handle];
    if (data && data.featured_image) {
      var src = data.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_' + size + 'x$1$2');
      return '<img src="' + src + '" alt="" style="width:100%;height:100%;object-fit:contain;border-radius:4px;">';
    }
    return this.icon('default');
  },

  preloadHandles: function(items) {
    items.forEach(function(it) { if (it.h) KG.fetchProduct(it.h, function(){}); });
  },

  // ─── Info Popup ───────────────────────────────────────────────────────────
  showPopup: function(handle, name) {
    var overlay = document.getElementById('kg-popup-overlay');
    var box     = document.getElementById('kg-popup-box');
    if (!overlay || !box) return;
    box.innerHTML = '<div style="text-align:center;padding:40px;color:#9ca3af;">Wird geladen…</div>';
    overlay.style.display = 'flex';
    this.fetchProduct(handle, function(data) {
      if (!data) {
        box.innerHTML = '<div style="padding:24px"><p style="color:#e53e3e">Produkt nicht gefunden.</p>'
          + '<button onclick="KG.closePopup()" style="margin-top:12px;padding:8px 16px;border:1px solid #d1d5db;border-radius:6px;cursor:pointer">Schliessen</button></div>';
        return;
      }
      var img = data.featured_image
        ? '<img src="' + data.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_400x$1$2') + '" alt="" style="width:100%;max-height:260px;object-fit:contain;border-radius:8px;margin-bottom:16px;">'
        : '';
      var price = data.price_min ? (data.price_min / 100).toLocaleString('de-CH', {style:'currency', currency:'CHF'}) : '';
      // Nur den ersten Teil (vor der Tabelle) — alles ab <table> abschneiden
      var desc = '';
      if (data.description) {
        var tableIdx = data.description.indexOf('<table');
        desc = tableIdx > 0 ? data.description.substring(0, tableIdx) : data.description;
        desc = desc.trim();
      }
      box.innerHTML =
        '<button onclick="KG.closePopup()" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:22px;cursor:pointer;color:#6b7280;">×</button>'
        + img
        + '<div style="font-size:11px;color:#008451;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;margin-bottom:4px;">' + (data.vendor || '') + '</div>'
        + '<div style="font-size:17px;font-weight:700;color:#1a1a1a;margin-bottom:8px;">' + data.title + '</div>'
        + (price ? '<div style="font-size:18px;font-weight:700;color:#008451;margin-bottom:12px;">' + price + '</div>' : '')
        + (desc ? '<div style="font-size:13px;color:#6b7280;line-height:1.6;margin-bottom:16px;">' + desc + '</div>' : '')
        + '<a href="/products/' + handle + '" target="_blank" style="display:inline-block;font-size:13px;color:#008451;text-decoration:underline;">Zum Produkt →</a>';
    });
  },

  closePopup: function() {
    var overlay = document.getElementById('kg-popup-overlay');
    if (overlay) overlay.style.display = 'none';
  },

  injectPopupHTML: function() {
    if (document.getElementById('kg-popup-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'kg-popup-overlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;align-items:center;justify-content:center;padding:20px;';
    overlay.addEventListener('click', function(e) { if (e.target === overlay) KG.closePopup(); });
    var box = document.createElement('div');
    box.id = 'kg-popup-box';
    box.style.cssText = 'position:relative;background:#fff;border-radius:12px;padding:28px 24px 24px;max-width:440px;width:100%;max-height:85vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,0.25);';
    overlay.appendChild(box);
    document.body.appendChild(overlay);
  },

  // ─── Icons ────────────────────────────────────────────────────────────────
  ICONS: {
    model:     '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="12" width="48" height="18" rx="3"/><rect x="4" y="7" width="14" height="8" rx="2"/><line x1="10" y1="30" x2="8" y2="40" stroke-linecap="round"/><line x1="46" y1="30" x2="44" y2="40" stroke-linecap="round"/><line x1="4" y1="40" x2="16" y2="40" stroke-linecap="round"/><line x1="40" y1="40" x2="52" y2="40" stroke-linecap="round"/></svg>',
    drop:      '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="10" width="48" height="20" rx="3"/><line x1="18" y1="10" x2="18" y2="30"/><line x1="38" y1="10" x2="38" y2="30"/><path d="M18 20 l9 10 l9-10" stroke-width="1.5" stroke-linecap="round"/></svg>',
    flexion:   '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 24 Q28 10 52 24" stroke-linecap="round"/><rect x="4" y="24" width="48" height="12" rx="3"/><line x1="10" y1="36" x2="8" y2="42" stroke-linecap="round"/><line x1="46" y1="36" x2="44" y2="42" stroke-linecap="round"/></svg>',
    headpiece: '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="18" y="4" width="20" height="14" rx="4"/><rect x="4" y="18" width="48" height="16" rx="3"/><line x1="28" y1="18" x2="28" y2="4"/><line x1="10" y1="34" x2="8" y2="42" stroke-linecap="round"/><line x1="46" y1="34" x2="44" y2="42" stroke-linecap="round"/></svg>',
    chest:     '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="10" width="48" height="22" rx="3"/><rect x="12" y="6" width="32" height="7" rx="2"/><line x1="28" y1="13" x2="28" y2="32"/><line x1="10" y1="32" x2="8" y2="42" stroke-linecap="round"/><line x1="46" y1="32" x2="44" y2="42" stroke-linecap="round"/></svg>',
    pelvic:    '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><ellipse cx="28" cy="30" rx="22" ry="9"/><line x1="28" y1="21" x2="28" y2="12"/><path d="M12 25 Q6 32 12 38" stroke-linecap="round"/><path d="M44 25 Q50 32 44 38" stroke-linecap="round"/></svg>',
    foot:      '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="18" y="6" width="20" height="30" rx="5"/><ellipse cx="28" cy="36" rx="12" ry="5"/><line x1="28" y1="6" x2="28" y2="2" stroke-linecap="round"/></svg>',
    farbe:     '<svg viewBox="0 0 56 44" fill="none"><circle cx="18" cy="16" r="9" fill="#1c3f6e"/><circle cx="38" cy="16" r="9" fill="#6b1f2a"/><circle cx="28" cy="32" r="9" fill="#2d6a4f"/></svg>',
    default:   '<svg viewBox="0 0 56 44" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="6" y="12" width="44" height="18" rx="3"/><line x1="12" y1="30" x2="10" y2="40" stroke-linecap="round"/><line x1="44" y1="30" x2="42" y2="40" stroke-linecap="round"/></svg>'
  },

  icon: function(t) { return this.ICONS[t] || this.ICONS.default; },
  gm:   function() { var s=this.sel; return this.MODELS.find(function(x){return x.id===s.model;})||null; },
  find: function(a,id) { return a.find(function(x){return x.id===id;})||null; },

  // ─── Option card builder ──────────────────────────────────────────────────
  opt: function(it, sel, multi, iconType) {
    var imgContent = (it.h && this._imgCache[it.h] && this._imgCache[it.h].featured_image)
      ? this.imgTag(it.h, 120)
      : this.icon(iconType);
    var inclBadge = it.incl
      ? '<span class="kg-incl-right">inklusive</span>'
      : '';
    // Info-Button overlay auf dem Bild
    var infoBtn = it.h
      ? '<button class="kg-info-btn kg-info-btn--overlay" data-handle="' + it.h + '" data-name="' + it.n + '" onclick="event.stopPropagation();KG.showPopup(this.dataset.handle,this.dataset.name)">'
        + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="8" stroke-linecap="round" stroke-width="3"/><line x1="12" y1="12" x2="12" y2="16" stroke-linecap="round"/></svg>'
        + '</button>'
      : '';
    // Preis direkt auf der Karte
    var cached = it.h && this._imgCache[it.h];
    var price = (cached && cached.price_min)
      ? '<div class="kg-opt-price">' + (cached.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) + '</div>'
      : '';
    var chk = multi
      ? '<div class="kg-opt-mchk">' + (sel ? '&#10003;' : '') + '</div>'
      : '<div class="kg-opt-chk">'  + (sel ? '&#10003;' : '') + '</div>';
    // Name + Preis in einer Zeile
    var rightCol = '';
    if (it.incl) {
      rightCol = '<span class="kg-incl-right">inklusive</span>';
    } else if (it.h) {
      var priceVal = (cached && cached.price_min && cached.price_min > 0)
        ? (cached.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'})
        : (cached ? 'CHF 0.00' : '…');
      rightCol = '<div class="kg-opt-price-inline">' + priceVal + '</div>';
    }
    var namePrice = '<div style="display:flex;align-items:baseline;justify-content:space-between;gap:8px;">'
      + '<div class="kg-opt-name">' + it.n + '</div>'
      + rightCol
      + '</div>';
    // incl items: immer selektiert, nicht anklickbar, kein Checkbox
    if (it.incl) {
      return '<div class="kg-opt sel kg-opt-incl" data-id="' + it.id + '" style="cursor:default;">'
        + '<div class="kg-opt-img" style="position:relative;">' + imgContent + '</div>'
        + '<div class="kg-opt-txt">'
          + namePrice
          + (it.d ? '<div class="kg-opt-desc">' + it.d + '</div>' : '')
          + (it.sku ? '<div class="kg-opt-sku">' + it.sku + '</div>' : '')
        + '</div>'
        + '<div class="kg-opt-chk">&#10003;</div>'
        + '</div>';
    }
    return '<div class="kg-opt' + (sel ? ' sel' : '') + '" data-id="' + it.id + '">'
      + '<div class="kg-opt-img" style="position:relative;">' + imgContent + infoBtn + '</div>'
      + '<div class="kg-opt-txt">'
        + namePrice
        + (it.d ? '<div class="kg-opt-desc">' + it.d + '</div>' : '')
        + (it.sku ? '<div class="kg-opt-sku">' + it.sku + '</div>' : '')
      + '</div>'
      + chk
      + '</div>';
  },

  sg: function(id, html, fn) {
    var el = document.getElementById(id); if (!el) return;
    el.innerHTML = html;
    if (fn) el.querySelectorAll('.kg-opt').forEach(function(r) {
      if (r.classList.contains('kg-opt-incl')) return; // inkl. items nicht anklickbar
      r.addEventListener('click', fn);
    });
  },

  mark: function(n, done, txt) {
    var c = document.getElementById('kn' + n), v = document.getElementById('kv' + n);
    var labels = {'acfs':'2b'};
    var label = labels[n] !== undefined ? labels[n] : String(n);
    if (c) { if (done) { c.classList.add('done'); c.textContent = ''; } else { c.classList.remove('done'); c.textContent = label; } }
    if (v && txt !== undefined) v.textContent = txt;
  },

  openNext: function(n) {
    var next = document.getElementById('ks' + n);
    if (next && !next.classList.contains('open')) next.classList.add('open');
  },

  // ─── Render: after images loaded, refresh opt images ─────────────────────
  refreshOptImages: function(containerId, items, selFn, multiFn, iconType, clickFn) {
    var el = document.getElementById(containerId); if (!el) return;
    el.querySelectorAll('.kg-opt').forEach(function(card) {
      var id   = card.dataset.id;
      var it   = items.find(function(x) { return x.id === id; });
      if (!it || !it.h) return;
      var imgEl = card.querySelector('.kg-opt-img');
      if (!imgEl) return;
      var cached = KG._imgCache[it.h];
      if (cached && cached.featured_image) {
        imgEl.innerHTML = KG.imgTag(it.h, 120);
      }
    });
  },

  // ─── Render sections ──────────────────────────────────────────────────────
  rModels: function() {
    var self = this, s = this.sel, h = '';
    this.MODELS.forEach(function(m) {
      var sel = s.model === m.id;
      var cached = m.h ? self._imgCache[m.h] : null;
      var imgSrc = cached && cached.featured_image ? cached.featured_image : null;
      var imgInner = imgSrc
        ? '<img src="' + imgSrc + '" alt="">'
        : '<div class="kg-model-img-ph"></div>';
      var imgC = '<div class="kg-model-img-wrap">' + imgInner + '</div>';
      h += '<div class="kg-model-card' + (sel ? ' sel' : '') + '" data-id="' + m.id + '">'
        + imgC
        + '<div class="kg-model-card-txt">'
          + '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px;"><div class="kg-model-name kg-model-title" data-default="' + m.n + '">' + m.n + '</div><div class="kg-model-price" style="font-size:12px;font-weight:700;color:#008451;white-space:nowrap;"></div></div>'
          + '<div class="kg-model-sub">' + m.s + '</div>'
          + '<span class="kg-model-badge ' + (m.c === 'auto' ? 'kg-badge-auto' : 'kg-badge-man') + '">' + (m.c === 'auto' ? 'Auto' : 'Manual') + '</span>'
        + '</div>'
        + '</div>';
    });
    var g = document.getElementById('model-grid'); if (!g) return;
    g.innerHTML = h;
    // Use event delegation so clicks always work even after re-renders
    if (!g._kgDelegated) {
      g._kgDelegated = true;
      g.addEventListener('click', function(e) {
        var card = e.target.closest('.kg-model-card');
        if (!card) return;
        var id = card.dataset.id;
        if (!id) return;
        if (s.model !== id) { s.model = id; s.drops = []; s.flexion = null; s.lad = null; s.acfs = null; s.tensionfs = null; s.pelvic = null; s.tbar = null; }
        self.render(); self.openNext(2);
      });
    }
    var cur = this.gm();
    this.mark(1, !!s.model, cur ? cur.n : '');
    // Lazy-load images
    this.MODELS.forEach(function(m) {
      if (!m.h) return;
      KG.fetchProduct(m.h, function() {
        var cached = KG._imgCache[m.h];
        if (!cached || !cached.featured_image) return;
        var cards = document.querySelectorAll('#model-grid .kg-model-card[data-id="' + m.id + '"]');
        cards.forEach(function(card) {
          // Update image
          var wrap = card.querySelector('.kg-model-img-wrap');
          if (wrap && !wrap.querySelector('img')) {
            var img = document.createElement('img');
            img.src = cached.featured_image;
            img.alt = '';
            wrap.innerHTML = '';
            wrap.appendChild(img);
          }
          // Update title with real API product title
          var titleEl = card.querySelector('.kg-model-title');
          if (titleEl && cached.title) titleEl.textContent = cached.title;
          // Update price
          var txt = card.querySelector('.kg-model-card-txt');
          var priceEl = txt ? txt.querySelector('.kg-model-price') : null;
          if (priceEl && cached.price_min) {
            priceEl.textContent = (cached.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'});
          }
        });
      });
    });
  },
  rDrops: function() {
    var self = this, s = this.sel, m = this.gm(); if (!m) return;
    var note = document.getElementById('cocking-note');
    if (note) {
      note.classList.add('vis');
      note.textContent = m.c === 'auto'
        ? 'Auto-Cocking: Thoracic, Lumbar und Pelvic Drop sind im Basismodell enthalten.'
        : 'Manual Cocking: Wählen Sie 0–3 Drop-Optionen.';
    }
    if (m.c === 'auto') {
      this.sg('drops-grid', '', null);
      this.mark(2, true, 'Im Basismodell'); return;
    }
    var h = ''; this.DROPS.forEach(function(d) { h += self.opt(d, s.drops.indexOf(d.id) >= 0, true, 'drop'); });
    this.sg('drops-grid', h, function(e) {
      var id = e.currentTarget.dataset.id, idx = s.drops.indexOf(id);
      if (idx >= 0) s.drops.splice(idx, 1); else s.drops.push(id);
      self.render();
    });
    this.preloadAndRefresh('drops-grid', this.DROPS, 'drop');
    this.mark(2, s.drops.length > 0, s.drops.length ? s.drops.length + ' gewählt' : '');
  },

  rAcfs: function() {
    var self = this, s = this.sel, m = this.gm(); if (!m) return;
    if (m.c !== 'auto') {
      this.sg('acfs-grid', '<p style="font-size:13px;color:#6b7280;padding:6px 0">Nur für Auto-Cocking Modelle.</p>', null);
      this.mark('acfs', false, ''); return;
    }
    var h = ''; this.ACFS.forEach(function(a) { h += self.opt(a, s.acfs === a.id, false, 'foot'); });
    this.sg('acfs-grid', h, function(e) { s.acfs = e.currentTarget.dataset.id; self.render(); });
    this.preloadAndRefresh('acfs-grid', this.ACFS, 'foot');
    var ac = s.acfs ? this.find(this.ACFS, s.acfs) : null;
    this.mark('acfs', !!s.acfs, ac ? ac.n : '');
  },

  rFlexion: function() {
    var self = this, s = this.sel, m = this.gm(); if (!m) return;
    var ls = document.getElementById('lad-sec');
    var ts = document.getElementById('tensionfs-sec');
    if (m.ser !== 'fx') {
      this.sg('flexion-grid', '<p style="font-size:13px;color:#6b7280;padding:6px 0">Nur für FX-Modelle.</p>', null);
      if (ls) ls.style.display = 'none';
      if (ts) ts.style.display = 'none';
      this.mark(3, true, 'Nicht verfügbar'); return;
    }
    if (ls) ls.style.display = '';
    if (ts) ts.style.display = '';
    var h = ''; this.FLEXION.forEach(function(f) { h += self.opt(f, s.flexion === f.id, false, 'flexion'); });
    this.sg('flexion-grid', h, function(e) { s.flexion = e.currentTarget.dataset.id; s.lad = null; s.tensionfs = null; self.render(); self.openNext(4); });
    this.preloadAndRefresh('flexion-grid', this.FLEXION, 'flexion');
    // LAD
    var lh = ''; this.LAD.forEach(function(l) {
      var show = l.id === 'ln' || (l.id === 'lm' && s.flexion === 'fm') || (l.id === 'la' && s.flexion === 'fa');
      if (show) lh += self.opt(l, s.lad === l.id, false, 'default');
    });
    this.sg('lad-grid', lh, function(e) { s.lad = e.currentTarget.dataset.id; self.render(); });
    // Tension FS
    var tsh = ''; this.TENSIONFS.forEach(function(t) { tsh += self.opt(t, s.tensionfs === t.id, false, 'foot'); });
    this.sg('tensionfs-grid', tsh, function(e) { s.tensionfs = e.currentTarget.dataset.id; self.render(); });
    this.preloadAndRefresh('tensionfs-grid', this.TENSIONFS, 'foot');
    var fl = s.flexion ? this.find(this.FLEXION, s.flexion) : null;
    this.mark(3, !!s.flexion, fl ? fl.n : '');
  },

  rHeadpiece: function() {
    var self = this, s = this.sel, h = '';
    this.HP.forEach(function(x) { h += self.opt(x, s.hp === x.id, false, 'headpiece'); });
    this.sg('headpiece-grid', h, function(e) { s.hp = e.currentTarget.dataset.id; self.render(); self.openNext(5); });
    this.preloadAndRefresh('headpiece-grid', this.HP, 'headpiece');
    var lh = ''; this.LAT.forEach(function(x) { lh += self.opt(x, s.lat === x.id, false, 'headpiece'); });
    this.sg('lateral-grid', lh, function(e) { s.lat = e.currentTarget.dataset.id; self.render(); });
    var hp = s.hp ? this.find(this.HP, s.hp) : null;
    this.mark(4, !!s.hp, hp ? hp.n : '');
  },

  rChest: function() {
    var self = this, s = this.sel, m = this.gm(); if (!m) return;
    var h = ''; this.CHEST.forEach(function(c) { if (c.ser.indexOf(m.ser) >= 0) h += self.opt(c, s.chest === c.id, false, 'chest'); });
    this.sg('chest-grid', h, function(e) { s.chest = e.currentTarget.dataset.id; self.render(); self.openNext(6); });
    this.preloadAndRefresh('chest-grid', this.CHEST, 'chest');
    var ps = document.getElementById('pelvic-sec');
    if (m.ser === 'fx') { if (ps) ps.style.display = 'none'; }
    else {
      if (ps) ps.style.display = '';
      var ph = ''; this.PELVIC.forEach(function(p) { ph += self.opt(p, s.pelvic === p.id, false, 'pelvic'); });
      this.sg('pelvic-grid', ph, function(e) { s.pelvic = e.currentTarget.dataset.id; self.render(); });
      this.preloadAndRefresh('pelvic-grid', this.PELVIC, 'pelvic');
    }
    var ch = s.chest ? this.find(this.CHEST, s.chest) : null;
    this.mark(5, !!s.chest, ch ? ch.n : '');
  },

  rElev: function() {
    var self = this, s = this.sel, m = this.gm(); if (!m) return;
    var tbs = document.getElementById('tbar-sec');
    if (m.ser === 'hylo') {
      this.sg('elevation-grid', '<p style="font-size:13px;color:#6b7280;padding:6px 0">Nicht für Hylo verfügbar.</p>', null);
    } else {
      var h = ''; this.ELEV.forEach(function(e) { h += self.opt(e, s.elev === e.id, false, 'foot'); });
      this.sg('elevation-grid', h, function(e) { s.elev = e.currentTarget.dataset.id; self.render(); });
      this.preloadAndRefresh('elevation-grid', this.ELEV, 'foot');
    }
    if (m.ser !== 'fx') { if (tbs) tbs.style.display = 'none'; }
    else {
      if (tbs) tbs.style.display = '';
      var th = ''; this.TBAR.forEach(function(t) { th += self.opt(t, s.tbar === t.id, false, 'default'); });
      this.sg('tbar-grid', th, function(e) { s.tbar = e.currentTarget.dataset.id; self.render(); });
      this.preloadAndRefresh('tbar-grid', this.TBAR, 'default');
    }
    this.mark(6, !!(s.elev || s.tbar), (s.elev || s.tbar) ? 'Ausgewählt' : '');
  },

  rFarbe: function() {
    var self = this, s = this.sel;
    var makeStrip = function(containerId, size) {
      var el = document.getElementById(containerId); if (!el) return;
      var h = '';
      self.FARBEN.forEach(function(f) {
        h += '<div class="kg-fdot' + (s.farbe === f.id ? ' active' : '') + '" data-id="' + f.id + '" style="background:' + f.hex + ';width:' + size + 'px;height:' + size + 'px">'
          + '<span class="kg-fdot-tip">' + f.n + '</span></div>';
      });
      el.innerHTML = h;
      el.querySelectorAll('.kg-fdot').forEach(function(d) {
        d.addEventListener('click', function() { s.farbe = this.dataset.id; self.render(); self.openNext(8); });
      });
    };
    makeStrip('farbe-grid', 32);
    var fc = s.farbe ? this.find(this.FARBEN, s.farbe) : null;
    var fl = document.getElementById('farbe-name-label'); if (fl) fl.textContent = fc ? fc.n : '';
    this.mark(7, !!s.farbe, fc ? fc.n : '');
    var polster = document.getElementById('kg-polster');
    if (polster) { polster.setAttribute('fill', fc ? fc.hex : '#4a4a4a'); polster.setAttribute('opacity', fc ? '0.65' : '0.15'); }
  },

  rZub: function() {
    var self = this, s = this.sel, h = '';
    this.ZUB.forEach(function(z) { h += self.opt(z, s.zub.indexOf(z.id) >= 0, true, 'default'); });
    this.sg('zub-grid', h, function(e) {
      var id = e.currentTarget.dataset.id, idx = s.zub.indexOf(id);
      if (idx >= 0) s.zub.splice(idx, 1); else s.zub.push(id);
      self.render();
    });
    this.preloadAndRefresh('zub-grid', this.ZUB, 'default');
    this.mark(8, s.zub.length > 0, s.zub.length ? s.zub.length + ' gewählt' : 'Optional');
  },

  // Preload images for a container and update cards when done
  preloadAndRefresh: function(containerId, items, iconType) {
    var self = this;
    items.forEach(function(it) {
      if (!it.h) return;
      if (self._imgCache[it.h] !== undefined) {
        self._updateOptImg(containerId, it);
      } else {
        KG.fetchProduct(it.h, function() {
          self._updateOptImg(containerId, it);
          self._updateOptPrice(containerId, it);
        });
      }
    });
  },

  _updateOptPrice: function(containerId, it) {
    if (!it.h) return;
    var cached = this._imgCache[it.h];
    if (!cached) return; // API not yet loaded
    // Continue even if price_min is 0 or null — show CHF 0.00
    var priceStr = (cached.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'});
    var finalPrice = (cached && cached.price_min && cached.price_min > 0)
      ? (cached.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'})
      : 'CHF 0.00';
    var cards = document.querySelectorAll('#' + containerId + ' [data-id="' + it.id + '"]');
    cards.forEach(function(card) {
      var inline = card.querySelector('.kg-opt-price-inline');
      if (inline) { inline.textContent = finalPrice; return; }
      var nameEl = card.querySelector('.kg-opt-name');
      if (nameEl && nameEl.parentNode) {
        var priceEl = document.createElement('div');
        priceEl.className = 'kg-opt-price-inline';
        priceEl.style.cssText = 'font-size:12px;font-weight:700;color:#008451;white-space:nowrap;flex-shrink:0;';
        priceEl.textContent = finalPrice;
        nameEl.parentNode.style.cssText = 'display:flex;align-items:baseline;justify-content:space-between;gap:8px;';
        nameEl.parentNode.appendChild(priceEl);
      }
    });
  },

  _updateOptImg: function(containerId, it) {
    if (!it.h) return;
    var cached = this._imgCache[it.h];
    if (!cached || !cached.featured_image) return;
    var cards = document.querySelectorAll('#' + containerId + ' .kg-opt[data-id="' + it.id + '"]');
    cards.forEach(function(card) {
      var imgEl = card.querySelector('.kg-opt-img');
      if (!imgEl || imgEl.querySelector('img')) return;
      imgEl.innerHTML = KG.imgTag(it.h, 120);
    });
  },

  // ─── Cart builder ─────────────────────────────────────────────────────────
  buildLines: function() {
    var s = this.sel, m = this.gm(); if (!m) return [];
    var L = [];
    L.push({n:m.n, sku:m.sku, icon:'model', h:m.h, step:1});
    if (m.c === 'auto') {
      L.push({n:"Kompressor Super Silent 240V", sku:"2000412", icon:'default'});
      var ac = s.acfs ? this.find(this.ACFS, s.acfs) : null;
      if (ac && ac.sku) L.push({n:ac.n, sku:ac.sku, icon:'foot', incl:ac.incl, h:ac.h, step:'acfs'});
    } else {
      s.drops.forEach(function(id) { var d = KG.find(KG.DROPS, id); if (d && d.sku) L.push({n:d.n, sku:d.sku, icon:'drop', h:d.h, step:2}); });
    }
    if (m.ser === 'fx') {
      if (s.lad && s.lad !== 'ln') { var lad = this.find(this.LAD, s.lad); if (lad && lad.sku) L.push({n:lad.n, sku:lad.sku, icon:'flexion', h:lad.h, step:3}); }
      else if (s.flexion) { var fl = this.find(this.FLEXION, s.flexion); if (fl && fl.sku) L.push({n:fl.n, sku:fl.sku, icon:'flexion', h:fl.h, step:3}); }
      if (s.tensionfs) { var tf = this.find(this.TENSIONFS, s.tensionfs); if (tf && tf.sku) L.push({n:tf.n, sku:tf.sku, icon:'foot', incl:tf.incl, h:tf.h, step:3}); }
    }
    if (s.hp)  { var hp  = this.find(this.HP, s.hp);   if (hp  && hp.sku)  L.push({n:hp.n,  sku:hp.sku,  icon:'headpiece', h:hp.h, step:4}); }
    if (s.lat && s.lat !== 'lno') { var lat = this.find(this.LAT, s.lat); if (lat && lat.sku) L.push({n:lat.n, sku:lat.sku, icon:'headpiece', h:lat.h, step:4}); }
    if (s.chest)  { var ch = this.find(this.CHEST, s.chest);   if (ch  && ch.sku)  L.push({n:ch.n,  sku:ch.sku,  icon:'chest',  incl:ch.incl, h:ch.h, step:5}); }
    if (m.ser !== 'fx' && s.pelvic) { var pv = this.find(this.PELVIC, s.pelvic); if (pv && pv.sku) L.push({n:pv.n, sku:pv.sku, icon:'pelvic', incl:pv.incl, h:pv.h, step:5}); }
    if (m.ser !== 'hylo' && s.elev) { var ev = this.find(this.ELEV, s.elev); if (ev && ev.sku) L.push({n:ev.n, sku:ev.sku, icon:'foot', incl:ev.incl, h:ev.h, step:6}); }
    if (m.ser === 'fx' && s.tbar && s.tbar !== 'tn') { var tb = this.find(this.TBAR, s.tbar); if (tb && tb.sku) L.push({n:tb.n, sku:tb.sku, icon:'default', h:tb.h, step:6}); }
    if (s.farbe) { var fc = this.find(this.FARBEN, s.farbe); if (fc) L.push({n:"Polster " + fc.n, sku:fc.sku, icon:'farbe', h:fc.h, step:7}); }
    s.zub.forEach(function(id) { var z = KG.find(KG.ZUB, id); if (z && z.sku) L.push({n:z.n, sku:z.sku, icon:'default', incl:z.incl, h:z.h, step:8}); });
    L.push({n:"Cord Set Swiss", sku:"1608879", auto:true, icon:'default', h:'cord-set-swiss-86515050-iec320-85101'});
    L.push({n:"Kit Strap Ankle Flexion", sku:"1330929", auto:true, icon:'default', h:'kit-strap-ankle-flexion-table'});
    return L;
  },

  rCart: function() {
    var lines = this.buildLines(), s = this.sel;
    var cnt  = document.getElementById('sum-count'),  body = document.getElementById('sum-lines');
    var btn  = document.getElementById('add-to-cart-btn'), hint = document.getElementById('cta-hint'), bar = document.getElementById('cta-bar');
    var totalEl = document.getElementById('sum-total');
    if (cnt) cnt.textContent = lines.length + ' Artikel';
    var done = 0; if (s.model) done++; if (s.hp) done++; if (s.chest) done++; if (s.farbe) done++;
    if (bar) bar.style.width = Math.round(done / 4 * 100) + '%';
    if (!body) return;

    // Gesamtpreis berechnen
    var total = 0;
    lines.forEach(function(l) {
      if (l.h) {
        var cached = KG._imgCache[l.h];
        if (cached && cached.price_min) total += cached.price_min;
      }
    });
    if (totalEl) {
      totalEl.textContent = total > 0
        ? 'Gesamt: ' + (total/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'})
        : '';
    }

    if (lines.length === 0) { body.innerHTML = '<p class="kg-sum-empty">Noch keine Auswahl getroffen.</p>'; return; }

    body.innerHTML = lines.map(function(l) {
      var cached = l.h ? KG._imgCache[l.h] : null;
      var img = (cached && cached.featured_image)
        ? '<img src="' + cached.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_80x$1$2') + '" alt="" style="width:36px;height:28px;object-fit:contain;border-radius:4px;">'
        : KG.icon(l.icon);
      var price = (cached && cached.price_min)
        ? '<span class="kg-sline-price">' + (cached.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) + '</span>'
        : '';
      var stepLink = l.step
        ? '<button class="kg-sline-edit" onclick="KG.jumpToStep(' + l.step + ')" title="Zur Auswahl">'
          + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>'
          + '</button>'
        : '';
      return '<div class="kg-sline">'
        + '<div class="kg-sline-img">' + img + '</div>'
        + '<div class="kg-sline-info">'
          + '<div class="kg-sline-top">'
            + '<div class="kg-sline-name">' + l.n
              + (l.auto ? '<span class="kg-atag">auto</span>' : '')
              + (l.incl ? '<span style="font-size:10px;color:#008451;font-weight:500;margin-left:4px;">inklusive</span>' : '')
            + '</div>'
            + price
          + '</div>'
          + '<div class="kg-sline-sku">' + (l.sku || '') + '</div>'
        + '</div>'
        + stepLink
        + '</div>';
    }).join('');

    var ok = s.model && s.hp && s.chest && s.farbe;
    if (btn)  btn.disabled = !ok;
    if (hint) hint.style.display = ok ? 'none' : 'block';
  },

  jumpToStep: function(n) {
    // Close all, open target
    document.querySelectorAll('.kg-step').forEach(function(s) { s.classList.remove('open'); });
    var target = document.getElementById('ks' + n);
    if (target) {
      target.classList.add('open');
      target.scrollIntoView({behavior:'smooth', block:'start'});
    }
  },

  render: function() {
    this.rModels(); var m = this.gm();
    if (m) { this.rDrops(); this.rAcfs(); this.rFlexion(); this.rHeadpiece(); this.rChest(); this.rElev(); this.rFarbe(); this.rZub(); }
    this.rCart();
  },

  _closeAllOverlays: function() {
    ['kg-sum-overlay','kg-form-overlay','kg-popup-overlay'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
  },

  // ─── Summary Popup ────────────────────────────────────────────────────────
  showSummaryPopup: function() {
    var self = this;
    var lines = this.buildLines();
    var total = 0;
    lines.forEach(function(l) {
      if (l.h) { var c = KG._imgCache[l.h]; if (c && c.price_min) total += c.price_min; }
    });
    var totalStr = total > 0 ? (total/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) : '';

    // Build lines HTML
    var linesHtml = lines.map(function(l) {
      var c = l.h ? KG._imgCache[l.h] : null;
      var img = (c && c.featured_image)
        ? '<img src="' + c.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_80x$1$2') + '" alt="" style="width:44px;height:36px;object-fit:contain;border-radius:4px;">'
        : '<div style="width:44px;height:36px;background:#f5f5f5;border-radius:4px;"></div>';
      var price = (c && c.price_min && c.price_min > 0)
        ? '<span style="font-size:12px;font-weight:700;color:#008451;white-space:nowrap;margin-left:8px;">' + (c.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) + '</span>'
        : (l.incl ? '<span style="font-size:11px;color:#008451;margin-left:8px;">inklusive</span>' : '');
      return '<div style="display:flex;align-items:center;gap:10px;padding:7px 0;border-bottom:1px solid rgba(0,0,0,0.06);">'
        + '<div style="flex-shrink:0;">' + img + '</div>'
        + '<div style="flex:1;min-width:0;">'
          + '<div style="font-size:13px;font-weight:500;color:#1a1a1a;">' + l.n
            + (l.auto ? ' <span style="font-size:9px;background:#e6f4ec;color:#085041;padding:1px 5px;border-radius:3px;font-weight:600;">auto</span>' : '')
          + '</div>'
          + '<div style="font-size:10px;color:#9ca3af;font-family:monospace;">' + (l.sku||'') + '</div>'
        + '</div>'
        + price
        + '</div>';
    }).join('');

    var overlay = document.getElementById('kg-sum-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'kg-sum-overlay';
      overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:10000;align-items:center;justify-content:center;padding:16px;';
      overlay.addEventListener('click', function(e) { if (e.target===overlay) self.closeSummaryPopup(); });
      document.body.appendChild(overlay);
    }

    overlay.innerHTML = '<div id="kg-sum-box" style="background:#fff;border-radius:14px;max-width:520px;width:100%;max-height:90vh;display:flex;flex-direction:column;box-shadow:0 24px 64px rgba(0,0,0,0.25);">'
      // Header
      + '<div style="padding:20px 24px 14px;border-bottom:1px solid rgba(0,0,0,0.08);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;">'
        + '<div>'
          + '<img src="https://cdn.shopify.com/s/files/1/0854/2860/1176/files/Medidor_Logo_CMYK_400x.png_1.png?v=1742224653" alt="Medidor" style="height:28px;object-fit:contain;">'
        + '</div>'
        + '<div style="text-align:right;">'
          + '<div style="font-size:11px;color:#9ca3af;">Ihre Konfiguration</div>'
          + (totalStr ? '<div style="font-size:18px;font-weight:800;color:#008451;">' + totalStr + '</div>' : '')
        + '</div>'
        + '<button onclick="KG.closeSummaryPopup()" style="background:none;border:none;font-size:22px;cursor:pointer;color:#9ca3af;margin-left:16px;">×</button>'
      + '</div>'
      // Article list
      + '<div style="padding:12px 24px;overflow-y:auto;flex:1;">' + linesHtml + '</div>'
      // Action buttons
      + '<div style="padding:16px 24px;border-top:1px solid rgba(0,0,0,0.08);flex-shrink:0;">'
        + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">'
          + '<button onclick="KG.actionCart()" style="background:#008451;color:#fff;border:none;border-radius:8px;padding:12px;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.99-1.61L23 6H6"/></svg>'
            + 'In den Warenkorb</button>'
          + '<button onclick="KG.actionPDF()" style="background:#1a1a1a;color:#fff;border:none;border-radius:8px;padding:12px;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>'
            + 'Als PDF speichern</button>'
          + '<button onclick="KG.actionOfferte()" style="background:#fff;color:#008451;border:1.5px solid #008451;border-radius:8px;padding:12px;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>'
            + 'Offerte anfragen</button>'
          + '<button onclick="KG.actionBeratung()" style="background:#fff;color:#1a1a1a;border:1.5px solid rgba(0,0,0,0.15);border-radius:8px;padding:12px;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>'
            + 'Beratung anfragen</button>'
        + '</div>'
      + '</div>'
    + '</div>';

    overlay.style.display = 'flex';

    // Load customer data
    fetch('/account.js').then(function(r) { return r.ok ? r.json() : null; }).catch(function() { return null; })
      .then(function(cust) { KG._customer = cust; });
  },

  closeSummaryPopup: function() {
    this._closeAllOverlays();
  },

  actionCart: function() {
    alert('Warenkorb-Integration folgt nach Klärung des Workflows.');
  },

  _buildPDFHtml: function(custOverride) {
    var lines = this.buildLines();
    var total = 0;
    lines.forEach(function(l) {
      if (l.h) { var c = KG._imgCache[l.h]; if (c && c.price_min) total += c.price_min; }
    });
    var totalStr = total > 0 ? (total/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) : '';
    var date = new Date().toLocaleDateString('de-CH');
    var cust = custOverride || KG._customer || {};
    var addr = cust.default_address || {};
    var custName = ((cust.first_name||'') + ' ' + (cust.last_name||'')).trim();
    var custCompany = addr.company || cust.company || '';
    var custAddr = [addr.address1, addr.zip && addr.city ? addr.zip + ' ' + addr.city : addr.city].filter(Boolean).join(', ');
    var custPhone = cust.phone || addr.phone || '';
    var custEmail = cust.email || '';

    var rows = lines.map(function(l) {
      var c = l.h ? KG._imgCache[l.h] : null;
      var img = (c && c.featured_image)
        ? '<img src="' + c.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" style="width:56px;height:44px;object-fit:contain;display:block;">'
        : '<div style="width:56px;height:44px;background:#f5f5f5;border-radius:4px;"></div>';
      var price = '';
      if (l.incl || l.auto) {
        price = '<span style="color:#008451;font-weight:600;">inklusive</span>';
      } else if (c && c.price_min && c.price_min > 0) {
        price = '<strong style="color:#1a1a1a;">' + (c.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) + '</strong>';
      } else {
        price = '<span style="color:#9ca3af;">—</span>';
      }
      return '<tr>'
        + '<td style="padding:10px 8px;border-bottom:1px solid #f0f0f0;width:68px;vertical-align:middle;">' + img + '</td>'
        + '<td style="padding:10px 8px;border-bottom:1px solid #f0f0f0;vertical-align:middle;">'
          + '<div style="font-size:13px;font-weight:600;color:#1a1a1a;">' + l.n + '</div>'
          + '<div style="font-size:11px;color:#9ca3af;margin-top:2px;font-family:monospace;">' + (l.sku||'') + '</div>'
        + '</td>'
        + '<td style="padding:10px 8px;border-bottom:1px solid #f0f0f0;text-align:right;vertical-align:middle;font-size:13px;white-space:nowrap;">' + price + '</td>'
        + '</tr>';
    }).join('');

    return '<!DOCTYPE html><html><head><meta charset="utf-8">'
      + '<title>Konfiguration Therapieliege — Medidor</title>'
      + '<style>'
      + 'body{font-family:Helvetica,Arial,sans-serif;margin:0;padding:0;color:#1a1a1a;font-size:13px;}'
      + '@page{size:A4;margin:18mm 20mm;}'
      + '@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}}'
      + 'table{width:100%;border-collapse:collapse;}'
      + '</style></head><body>'

      // Header
      + '<table style="width:100%;margin-bottom:28px;"><tr>'
        + '<td style="vertical-align:top;">'
          + '<img src="https://cdn.shopify.com/s/files/1/0854/2860/1176/files/Medidor_Logo_CMYK_400x.png_1.png?v=1742224653" style="height:36px;display:block;">'
          + '<div style="margin-top:6px;font-size:10px;color:#9ca3af;">medidor.ch</div>'
        + '</td>'
        + '<td style="text-align:right;vertical-align:top;">'
          + '<div style="font-size:22px;font-weight:800;color:#1a1a1a;letter-spacing:-0.5px;">Konfiguration Therapieliege</div>'
          + '<div style="font-size:12px;color:#6b7280;margin-top:4px;">Datum: ' + date + '</div>'
        + '</td>'
      + '</tr></table>'

      // Two-column: customer left, note right
      + '<table style="width:100%;margin-bottom:24px;"><tr>'
        + '<td style="width:50%;vertical-align:top;padding-right:20px;">'
          + '<div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#9ca3af;margin-bottom:8px;">Kunde</div>'
          + (custName ? '<div style="font-weight:600;">' + custName + '</div>' : '')
          + (custCompany ? '<div>' + custCompany + '</div>' : '')
          + (custAddr ? '<div style="color:#6b7280;">' + custAddr + '</div>' : '')
          + (custPhone ? '<div style="color:#6b7280;">' + custPhone + '</div>' : '')
          + (custEmail ? '<div style="color:#6b7280;">' + custEmail + '</div>' : '')
        + '</td>'
        + '<td style="width:50%;vertical-align:top;background:#f8f9fa;border-radius:8px;padding:12px 16px;">'
          + '<div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#9ca3af;margin-bottom:6px;">Hinweis</div>'
          + '<div style="font-size:12px;color:#6b7280;line-height:1.6;">Alle Preise in CHF inkl. MWST Dieses Dokument ist freibleibend und stellt kein verbindliches Angebot dar. Für eine verbindliche Offerte kontaktieren Sie uns.</div>'
        + '</td>'
      + '</tr></table>'

      // Divider
      + '<div style="border-top:2px solid #008451;margin-bottom:0;"></div>'

      // Article table
      + '<table><thead><tr style="background:#008451;">'
        + '<th style="padding:10px 8px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#fff;text-align:left;">Artikel</th>'
        + '<th style="padding:10px 8px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#fff;text-align:left;"></th>'
        + '<th style="padding:10px 8px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#fff;text-align:right;">Preis inkl. MWST</th>'
      + '</tr></thead><tbody>' + rows + '</tbody></table>'

      // Total
      + '<div style="border-top:2px solid #008451;margin-top:0;padding:14px 8px;display:flex;justify-content:flex-end;">'
        + '<table style="width:auto;"><tr>'
          + '<td style="font-size:15px;font-weight:700;padding-right:40px;color:#1a1a1a;">Gesamtbetrag inkl. MWST</td>'
          + '<td style="font-size:18px;font-weight:800;color:#008451;text-align:right;">' + (totalStr||'—') + '</td>'
        + '</tr></table>'
      + '</div>'

      // Footer
      + '<div style="margin-top:32px;padding-top:12px;border-top:1px solid #e5e7eb;display:flex;justify-content:space-between;font-size:10px;color:#9ca3af;">'
        + '<span>Medidor AG &bull; medidor.ch</span>'
        + '<span>Dieses Dokument ist freibleibend</span>'
      + '</div>'

      + '<script>window.onload=function(){window.print();}<\/script>'
      + '</body></html>';
  },

  actionPDF: function() {
    var self = this;

    // Load jsPDF then logo as base64, then generate
    var loadJsPDF = function(cb) {
      if (window.jspdf) { cb(); return; }
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = cb;
      document.head.appendChild(s);
    };
    var loadLogo = function(cb) {
      if (KG._logoBase64) { cb(KG._logoBase64); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        var canvas = document.createElement('canvas');
        canvas.width = img.width; canvas.height = img.height;
        canvas.getContext('2d').drawImage(img, 0, 0);
        KG._logoBase64 = canvas.toDataURL('image/png');
        cb(KG._logoBase64);
      };
      img.onerror = function() { cb(null); };
      img.src = 'https://cdn.shopify.com/s/files/1/0854/2860/1176/files/Medidor_Logo_CMYK_400x.png_1.png?v=1742224653';
    };
    loadJsPDF(function() {
      loadLogo(function(logoData) {
        self._logoBase64 = logoData;
        self._generatePDF();
      });
    });
  },

  _generatePDF: function() {
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({ unit: 'mm', format: 'a4' });
    var lines = this.buildLines();
    var total = 0;
    lines.forEach(function(l) {
      if (l.h) { var c = KG._imgCache[l.h]; if (c && c.price_min) total += c.price_min; }
    });
    var totalStr = total > 0 ? (total/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) : '';
    var date = new Date().toLocaleDateString('de-CH');
    var cust = KG._customer || {};
    var addr = cust.default_address || {};
    var custName = ((cust.first_name||'') + ' ' + (cust.last_name||'')).trim();

    var pageW = 210, margin = 20, contentW = pageW - margin * 2;
    var y = 22;

    // ── Header ──────────────────────────────────────────────
    // Absender-Adresse links
    doc.setFontSize(11); doc.setFont('helvetica','bold'); doc.setTextColor(26,26,26);
    doc.text('MEDiDOR AG', margin, y);
    doc.setFontSize(9); doc.setFont('helvetica','normal'); doc.setTextColor(107,114,128);
    doc.text('Lenzburgerstrasse 2', margin, y + 5);
    doc.text('5702 Niederlenz', margin, y + 9.5);
    doc.text('044 739 88 88', margin, y + 16);
    doc.text('mail@medidor.ch', margin, y + 20.5);
    // Titel rechts
    doc.setFontSize(20); doc.setFont('helvetica','bold'); doc.setTextColor(26,26,26);
    doc.text('Konfiguration Therapieliege', pageW - margin, y - 2, {align:'right'});
    doc.setFontSize(10); doc.setFont('helvetica','normal'); doc.setTextColor(107,114,128);
    doc.text('Datum: ' + date, pageW - margin, y + 5, {align:'right'});
    y += 26;

    // Grüne Linie
    doc.setDrawColor(0,132,81); doc.setLineWidth(0.8);
    doc.line(margin, y, pageW - margin, y);
    y += 8;

    // ── Zwei-Spalten: Kunde links, Hinweis rechts ────────────
    var colW = (contentW - 8) / 2;
    var yLeft = y, yRight = y;

    // Kunde links
    doc.setFontSize(8); doc.setFont('helvetica','bold');
    doc.setTextColor(156,163,175);
    doc.text('KUNDE', margin, yLeft); yLeft += 5;
    doc.setFont('helvetica','normal'); doc.setTextColor(26,26,26);
    if (custName)      { doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.text(custName, margin, yLeft); yLeft += 5; doc.setFontSize(9); doc.setFont('helvetica','normal'); }
    if (addr.company)  { doc.text(addr.company, margin, yLeft); yLeft += 4.5; }
    if (addr.address1) { doc.text(addr.address1, margin, yLeft); yLeft += 4.5; }
    if (addr.zip || addr.city) { doc.text(((addr.zip||'') + ' ' + (addr.city||'')).trim(), margin, yLeft); yLeft += 4.5; }
    if (cust.phone||addr.phone) { doc.setTextColor(107,114,128); doc.text((cust.phone||addr.phone), margin, yLeft); yLeft += 4.5; }
    if (cust.email)    { doc.setTextColor(107,114,128); doc.text(cust.email, margin, yLeft); yLeft += 4.5; }

    // Hinweis rechts
    var rx = margin + colW + 8;
    doc.setFillColor(248,249,250);
    doc.roundedRect(rx, yRight - 2, colW, 28, 2, 2, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(156,163,175);
    doc.text('HINWEIS', rx + 4, yRight + 3); yRight += 8;
    doc.setFont('helvetica','normal'); doc.setTextColor(107,114,128); doc.setFontSize(8);
    var hinweis = 'Alle Preise in CHF inkl. MWST\nDieses Dokument ist kein Angebot.\nPreisänderungen und Irrtum vorbehalten.';
    doc.text(hinweis, rx + 4, yRight + 2);

    y = Math.max(yLeft, y + 30) + 6;

    // ── Artikeltabelle ───────────────────────────────────────
    // Header
    doc.setFillColor(0,132,81);
    doc.rect(margin, y, contentW, 8, 'F');
    doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    doc.text('Artikel', margin + 3, y + 5.5);
    doc.text('Artikel-Nr.', margin + 108, y + 5.5);
    doc.text('Preis inkl. MWST', pageW - margin - 3, y + 5.5, {align:'right'});
    y += 8;

    // Rows
    doc.setFont('helvetica','normal');
    lines.forEach(function(l, i) {
      var c = l.h ? KG._imgCache[l.h] : null;
      var price = (c && c.price_min && c.price_min > 0)
        ? (c.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'})
        : 'inklusive';
      if (i % 2 === 0) { doc.setFillColor(248,249,250); doc.rect(margin, y, contentW, 9, 'F'); }
      doc.setFontSize(9); doc.setTextColor(26,26,26);
      var name = l.n.length > 60 ? l.n.substring(0,57) + '...' : l.n;
      doc.text(name, margin + 3, y + 6);
      doc.setTextColor(156,163,175);
      doc.text(l.sku || '', margin + 108, y + 6);
      doc.setTextColor(26,26,26);
      doc.text(price, pageW - margin - 3, y + 6, {align:'right'});
      doc.setDrawColor(240,240,240); doc.setLineWidth(0.2);
      doc.line(margin, y + 9, pageW - margin, y + 9);
      y += 9;
    });

    // ── Gesamtbetrag ────────────────────────────────────────
    y += 3;
    doc.setDrawColor(0,132,81); doc.setLineWidth(0.8);
    doc.line(margin, y, pageW - margin, y); y += 7;
    doc.setFontSize(12); doc.setFont('helvetica','bold');
    doc.setTextColor(26,26,26); doc.text('Gesamtbetrag inkl. MWST', margin, y);
    doc.setTextColor(26,26,26); doc.text(totalStr||'—', pageW - margin, y, {align:'right'});

    // ── Footer ───────────────────────────────────────────────
    y = 282;
    doc.setDrawColor(229,231,235); doc.setLineWidth(0.3);
    doc.line(margin, y, pageW - margin, y); y += 5;
    doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(156,163,175);
    doc.text('Medidor AG  •  medidor.ch  •  044 739 88 88  •  mail@medidor.ch', margin, y);

    doc.save('Konfiguration-Therapieliege-' + date.replace(/\./g, '-') + '.pdf');
  },

  _buildFormBody: function(subject) {
    var self = this;
    var cust = KG._customer || {};
    var addr = (cust.default_address) || {};

    var overlay = document.getElementById('kg-form-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'kg-form-overlay';
      overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:10001;align-items:center;justify-content:center;padding:16px;';
      overlay.addEventListener('click', function(e) { if (e.target===overlay) overlay.style.display='none'; });
      document.body.appendChild(overlay);
    }

    var pdfHint = '';

    overlay.innerHTML = '<div style="background:#fff;border-radius:14px;max-width:500px;width:100%;max-height:90vh;overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,0.25);">'
      + '<div style="padding:20px 24px 14px;border-bottom:1px solid rgba(0,0,0,0.08);display:flex;justify-content:space-between;align-items:center;">'
        + '<div style="font-size:16px;font-weight:700;color:#1a1a1a;">' + subject + '</div>'
        + '<button onclick="document.getElementById(' + "'kg-form-overlay'" + ').style.display=' + "'none'" + '" style="background:none;border:none;font-size:22px;cursor:pointer;color:#9ca3af;line-height:1;">×</button>'
      + '</div>'
      + '<div style="padding:20px 24px;">'
        + pdfHint
        + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">'
          + this._field('Name', 'kg-f-name', ((cust.first_name||'') + ' ' + (cust.last_name||'')).trim(), '', true)
          + this._field('Telefon', 'kg-f-phone', cust.phone||addr.phone||'', '', true)
          + this._field('Firma', 'kg-f-company', addr.company||'', 'col-span', false)
          + this._field('Debitor-Nr.', 'kg-f-debitor', '', '', false)
          + this._field('E-Mail', 'kg-f-email', cust.email||'', '', false)
          + this._field('Adresse', 'kg-f-address', addr.address1||'', 'col-span', false)
        + '</div>'
        + '<div style="margin-top:12px;">'
          + '<label style="font-size:12px;font-weight:600;color:#6b7280;display:block;margin-bottom:4px;">Bemerkungen</label>'
          + '<textarea id="kg-f-note" rows="3" style="width:100%;border:1px solid rgba(0,0,0,0.15);border-radius:6px;padding:8px;font-size:13px;box-sizing:border-box;resize:vertical;"></textarea>'
        + '</div>'
        + '<div id="kg-f-error" style="display:none;color:#e53e3e;font-size:12px;margin-top:8px;padding:8px 12px;background:#fff5f5;border-radius:6px;border:1px solid #fed7d7;"></div>'
        + '<button id="kg-send-btn" data-subject="' + subject + '" style="margin-top:14px;width:100%;background:#008451;color:#fff;border:none;border-radius:8px;padding:13px;font-size:14px;font-weight:700;cursor:pointer;">'
          + 'Anfrage senden &rarr;</button>'
      + '</div>'
    + '</div>';
    overlay.style.display = 'flex';
    // Event delegation — works even after innerHTML re-render
    if (!overlay._kgFormDelegated) {
      overlay._kgFormDelegated = true;
      overlay.addEventListener('click', function(e) {
        var btn = e.target.closest('#kg-send-btn');
        if (btn) KG._sendForm(btn.dataset.subject);
      });
    }
  },

  _field: function(label, id, val, cls, required) {
    var span = cls === 'col-span' ? 'grid-column:span 2;' : '';
    var req = required ? ' <span style="color:#e53e3e;">*</span>' : '';
    var border = required ? 'border:1.5px solid rgba(0,0,0,0.2);' : 'border:1px solid rgba(0,0,0,0.15);';
    return '<div style="' + span + '">'
      + '<label style="font-size:12px;font-weight:600;color:#6b7280;display:block;margin-bottom:4px;">' + label + req + '</label>'
      + '<input id="' + id + '" type="text" value="' + (val||'').replace(/"/g,'&quot;') + '" style="width:100%;' + border + 'border-radius:6px;padding:8px 10px;font-size:13px;box-sizing:border-box;">'
    + '</div>';
  },

  _sendForm: function(subject) {
    var v = function(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };
    var errEl = document.getElementById('kg-f-error');
    var btn = document.getElementById('kg-send-btn');

    // Validation
    var errors = [];
    if (!v('kg-f-name')) errors.push('Name ist erforderlich');
    if (!v('kg-f-phone') && !v('kg-f-email')) errors.push('Bitte Telefon oder E-Mail angeben');
    if (errors.length) {
      if (errEl) { errEl.textContent = errors.join(' — '); errEl.style.display = 'block'; }
      return;
    }
    if (errEl) errEl.style.display = 'none';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet…'; }

    // Build config text
    var lines = this.buildLines();
    var total = 0;
    lines.forEach(function(l) {
      if (l.h) { var c = KG._imgCache[l.h]; if (c && c.price_min) total += c.price_min; }
    });
    var totalStr = total > 0 ? (total/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'}) : '';
    var configText = '[KONFIGURATOR] ' + subject + '\n\n'
      + 'Name: ' + v('kg-f-name') + '\n'
      + (v('kg-f-company') ? 'Firma: ' + v('kg-f-company') + '\n' : '')
      + (v('kg-f-debitor') ? 'Debitor-Nr.: ' + v('kg-f-debitor') + '\n' : '')
      + (v('kg-f-phone') ? 'Tel: ' + v('kg-f-phone') + '\n' : '')
      + (v('kg-f-email') ? 'E-Mail: ' + v('kg-f-email') + '\n' : '')
      + (v('kg-f-address') ? 'Adresse: ' + v('kg-f-address') + '\n' : '')
      + (v('kg-f-note') ? '\nBemerkungen: ' + v('kg-f-note') + '\n' : '')
      + '\n--- Konfiguration ---\n'
      + lines.map(function(l) {
          var c = l.h ? KG._imgCache[l.h] : null;
          var price = (c && c.price_min && c.price_min > 0)
            ? ' — ' + (c.price_min/100).toLocaleString('de-CH',{style:'currency',currency:'CHF'})
            : (l.incl||l.auto ? ' — inklusive' : '');
          return l.sku + '  ' + l.n + price;
        }).join('\n')
      + (totalStr ? '\n\nGesamt inkl. MWST: ' + totalStr : '');

    // Find the hidden PFB form and fill it
    var wrapper = document.getElementById('kg-pfb-wrapper');
    if (!wrapper) {
      if (errEl) { errEl.textContent = 'Formular nicht gefunden. Bitte Seite neu laden.'; errEl.style.display = 'block'; }
      if (btn) { btn.disabled = false; btn.textContent = 'Anfrage senden →'; }
      return;
    }

    // Wait for PFB to render the form fields
    var attempt = 0;
    var trySubmit = function() {
      var form = wrapper.querySelector('form');
      var inputs = wrapper.querySelectorAll('input[type="text"], input[type="email"], textarea');
      if (!form || inputs.length === 0) {
        if (attempt++ < 20) { setTimeout(trySubmit, 300); return; }
        if (errEl) { errEl.textContent = 'Formular nicht bereit. Bitte Seite neu laden.'; errEl.style.display = 'block'; }
        if (btn) { btn.disabled = false; btn.textContent = 'Anfrage senden →'; }
        return;
      }

      // Fill fields by label or placeholder
      inputs.forEach(function(inp) {
        var label = '';
        if (inp.id) {
          var lEl = wrapper.querySelector('label[for="' + inp.id + '"]');
          if (lEl) label = lEl.textContent.trim().toLowerCase();
        }
        if (!label && inp.placeholder) label = inp.placeholder.toLowerCase();
        if (!label && inp.name) label = inp.name.toLowerCase();

        if (label.indexOf('name') >= 0 && label.indexOf('nach') < 0 && label.indexOf('firma') < 0) inp.value = v('kg-f-name');
        else if (label.indexOf('telefon') >= 0 || label.indexOf('phone') >= 0) inp.value = v('kg-f-phone');
        else if (label.indexOf('mail') >= 0) inp.value = v('kg-f-email') || 'keine@angabe.ch';
        else if (label.indexOf('nachricht') >= 0 || label.indexOf('message') >= 0 || label.indexOf('bemerkung') >= 0 || inp.tagName === 'TEXTAREA') inp.value = configText;

        // Trigger change event so PFB validation is happy
        inp.dispatchEvent(new Event('input', {bubbles: true}));
        inp.dispatchEvent(new Event('change', {bubbles: true}));
      });

      // Submit the form
      var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) {
        submitBtn.click();
        // Show success after short delay
        setTimeout(function() {
          var box = document.querySelector('#kg-form-overlay > div');
          if (box) {
            box.innerHTML = '<div style="padding:40px 24px;text-align:center;">'
              + '<div style="width:56px;height:56px;background:#e6f4ec;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;">'
                + '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#008451" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>'
              + '</div>'
              + '<div style="font-size:18px;font-weight:700;color:#1a1a1a;margin-bottom:8px;">Anfrage gesendet!</div>'
              + '<div style="font-size:13px;color:#6b7280;line-height:1.6;margin-bottom:24px;">Vielen Dank. Wir melden uns so bald wie möglich bei Ihnen.</div>'
              + '<button onclick="KG.closeSummaryPopup()" style="background:#008451;color:#fff;border:none;border-radius:8px;padding:12px 32px;font-size:14px;font-weight:600;cursor:pointer;">Schliessen</button>'
            + '</div>';
          }
        }, 1500);
      } else {
        if (errEl) { errEl.textContent = 'Submit-Button nicht gefunden.'; errEl.style.display = 'block'; }
        if (btn) { btn.disabled = false; btn.textContent = 'Anfrage senden →'; }
      }
    };

    // Make wrapper briefly visible so PFB renders
    wrapper.style.position = 'fixed';
    wrapper.style.left = '-9999px';
    wrapper.style.display = 'block';
    trySubmit();
  },

  actionOfferte: function() {
    this._buildFormBody('Offerte + Liefertermin anfragen');
  },

  actionBeratung: function() {
    this._buildFormBody('Beratung anfragen');
  },

  // ──────────────────────────────────────────────────────────────────────────
  init: function() {
    var self = this;
    this.injectPopupHTML();

    // CSS für Info-Button
    var style = document.createElement('style');
    style.textContent = ''
      + '.kg-info-btn{background:rgba(255,255,255,0.92);border:1px solid rgba(0,0,0,0.15);border-radius:50%;width:20px;height:20px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#6b7280;flex-shrink:0;transition:all 0.15s;padding:0;}'
      + '.kg-info-btn:hover{border-color:#008451;color:#008451;background:#fff;}'
      + '.kg-info-btn--overlay{position:absolute;top:3px;left:3px;z-index:2;}'
      + '.kg-opt-price{font-size:12px;font-weight:700;color:#008451;margin-top:3px;}' + '.kg-opt-price-inline{font-size:12px;font-weight:700;color:#008451;white-space:nowrap;flex-shrink:0;}'
      + '#model-grid .kg-opt{cursor:pointer;}';
    document.head.appendChild(style);

    var btn = document.getElementById('add-to-cart-btn');
    if (btn) {
      btn.addEventListener('click', function() { self.showSummaryPopup(); });
    }
    this.render();
  }
};

KG.init();
